module.exports = __webpack_public_path__ + "static/media/ico-floating-community.9cb2138b.svg";